import client from '/src/services/client.js';

export default {
    signIn : (data) => client.post('auth/signin', data),
    updatePassword : (data) => client.post('change/password', data)
}